import { useState, useEffect } from 'react';
import { createTask, eventTask } from '@/api/apiMethods.js';
import { toClaimFn } from '@/utils/fn/toClaimStore';
import { getTaskList } from '@/utils/fn/useTaskList.js';
import WebApp from '@twa-dev/sdk';
import iconStore from '@/utils/iconStore';
import userStore from '@/utils/userStore';
import { getShareLink } from '@/utils/fn/getShareLink';
import './css/task.css';

// eslint-disable-next-line react/prop-types
export default function Tasks({ onTaskStatusChange }) {
    const [TaskItems, setTaskItems] = useState([]);
    const [taskListData, setTaskListData] = useState([]);
    const [comTaskListData, setComTaskListData] = useState([]);
    const [waitGetAwardData, setWaitGetAwardData] = useState([]);
    const [, setIsClaiming] = useState(false); // Add state to track if claiming is in progress
    const [inviteUrl] = useState(`${import.meta.env.VITE_APP_URL}spin?invite_code=${userStore.user.id}`);
    const [taskLoadingStates, setTaskLoadingStates] = useState({});
    const [verifyLoadingStates, setverifyLoadingStates] = useState({});

    let cachedTaskItems = null;

    const fetchAndSetTaskItems = async () => {
        try {
            const { unfinishedItems, finishedItems, waitGetAwardItem } =
                await getTaskList();
            setComTaskListData(finishedItems);
            setWaitGetAwardData(waitGetAwardItem);
            const filteredItems = unfinishedItems.filter((item) => !item.ready);
            const groupedData = Object.values(
                filteredItems.reduce((acc, item) => {
                    const classify = item.classify;
                    if (!acc[classify]) {
                        acc[classify] = { title: classify, items: [] };
                    }
                    acc[classify].items.push(item);
                    return acc;
                }, {}),
            );
            cachedTaskItems = groupedData;
            setTaskItems(groupedData);
        } catch (error) {
            console.error('Error fetching task items:', error);
        }
    };

    useEffect(() => {
        fetchAndSetTaskItems();
        const storedData = sessionStorage.getItem('taskTimeoutData');
        if (storedData) {
            const tasksData = JSON.parse(storedData);
            const currentTime = Date.now();

            tasksData.forEach((taskData) => {
                const remainingTime = taskData.timeoutEndTime - currentTime;
                if (remainingTime > 0) {
                    setverifyLoadingStates((prevState) => ({
                        ...prevState,
                        [taskData.id]: true,
                    }));

                    setTimeout(async () => {
                        setverifyLoadingStates((prevState) => ({
                            ...prevState,
                            [taskData.id]: false,
                        }));
                        await createTask({ task_id: taskData.id, uid: userStore.user.id });
                        fetchAndSetTaskItems();
                    }, remainingTime);
                } else {
                    setverifyLoadingStates((prevState) => ({
                        ...prevState,
                        [taskData.id]: false,
                    }));
                }
            });
        }
    }, []);



    const updateTaskData = (item, res) => {
        const index = taskListData.findIndex((j) => j.id == res.event.task_id);
        if (index !== -1) {
            const newTaskListData = [...taskListData];
            newTaskListData[index] = { ...item, ...res.event };
            setTaskListData(newTaskListData);
        }
    };

    const TaskItemClick = async (item) => {
        // Immediately set the verifyLoadingStates to true when the task is clicked
        setverifyLoadingStates((prevState) => ({
            ...prevState,
            [item.id]: true,
        }));

        try {
            // Your existing logic to handle the task click
            if (item.classify == 'share_tg') {
                getShareLink('system_invite', 'user_action', inviteUrl);
            } else {
                if (item.url.includes('t.me')) {
                    window.open(item.url, '_blank');
                } else {
                    window.open(item.url, '_blank');
                }
            }

            const timeoutDuration = 30000; // 30 seconds
            const timeoutStartTime = Date.now();
            const timeoutEndTime = timeoutStartTime + timeoutDuration;

            // Save multiple task data in sessionStorage
            const taskData = { id: item.id, timeoutEndTime };
            let tasksData = JSON.parse(sessionStorage.getItem('taskTimeoutData')) || [];
            tasksData.push(taskData);

            sessionStorage.setItem('taskTimeoutData', JSON.stringify(tasksData));

            // Use setTimeout to delay the execution by 30 seconds
            setTimeout(async () => {
                const res = await createTask({ task_id: item.id, uid: userStore.user.id });
                const updatedItem = { ...item, ...res.event_info };
                updateTaskData(item, updatedItem);

                if (!cachedTaskItems) {
                    await fetchAndSetTaskItems();
                }

                cachedTaskItems = cachedTaskItems.map((task) =>
                    task.id === updatedItem.id ? updatedItem : task,
                );
                setTaskItems(cachedTaskItems);

                setverifyLoadingStates((prevState) => ({
                    ...prevState,
                    [item.id]: false,
                }));
            }, timeoutDuration); // 30 seconds delay
        } catch (error) {
            console.error('Error creating task:', error);
        }
    };

    const handleTaskComplete = (id) => {
        if (onTaskStatusChange) {
            console.log(id);
            onTaskStatusChange(id);
        }
    };

    const claimRewards = async (item, status) => {
        if (taskLoadingStates[item.id]) {
            console.log("Claiming already in progress for task", item.id);
            return;
        }
        setTaskLoadingStates((prevState) => ({
            ...prevState,
            [item.id]: true,
        }));

        setIsClaiming(true); // Set the claiming state to true to indicate claiming is in progress

        try {
            const arr = await eventTask({ uid: userStore.user.id });
            const matchedData = arr.filter(
                (task) => task.task_id === item.id && task.confirm === false,
            );
            console.log(matchedData, 'Matched Data');

            await toClaimFn(matchedData, status, taskListData, 'task');

            for (const prize of item.tasks_prize) {
                const rewardValue = Number(prize.reward_value);
                if (prize.currency_type === 'point') {
                    // handleTaskComplete('point');
                    // await new Promise((resolve) => setTimeout(resolve, 1200));
                    userStore.addPoint(rewardValue);
                } else if (prize.currency_type === 'credit') {
                    // handleTaskComplete('credit');
                    // await new Promise((resolve) => setTimeout(resolve, 2000));
                    userStore.addCredit(rewardValue);
                } else {
                    // handleTaskComplete('usdt');
                    // await new Promise((resolve) => setTimeout(resolve, 1200));
                    userStore.addUsdt(rewardValue);
                }
            }
            await fetchAndSetTaskItems();
        } catch (error) {
            console.error('Error claiming rewards:', error);
        } finally {
            setIsClaiming(false); // Set the claiming state back to false when the task is complete
            setTaskLoadingStates((prevState) => ({
                ...prevState,
                [item.id]: false,
            }));
        }
    };

    const renderTaskPrize = (prize, index) => {
        const currency = iconStore.currencyList?.find(
            (currency) => currency.key === prize.currency_type,
        );
        const iconUrl = currency ? `${currency.icon}` : '';

        return (
            <div key={index} className="flex items-center text-white">
                <img src={iconUrl} className="w-[24px] h-[24px]" alt="" />
                <p>+{prize.reward_value}</p>
            </div>
        );
    };

    const renderTaskItem = (item) => (
        <div className="w-full h-full mt-2" key={item.id}>
            <div
                className="h-full rounded-lg flex flex-col p-2 mb-2 task-body"
            >
                <div className="flex-grow">
                    <p className="text-base">{item.title}</p>
                    <div className="text-sm font-semibold h-8 text-white rounded inline-flex items-center px-2 desc-cor">
                        <span className="mr-2">{item.description}</span>
                    </div>
                </div>
                <div className="flex items-center justify-between text-xs">
                    <div className="w-32 flex justify-between">
                        {item.tasks_prize.map((taskPrize, index) => (
                            <div
                                key={index}
                                className="h-6 rounded-full flex items-center justify-center p-2"
                            >
                                {renderTaskPrize(taskPrize)}
                            </div>
                        ))}
                    </div>
                    <div
                        className={`w-24 h-7 ${verifyLoadingStates[item.id]
                            ? 'border-none text-[#999999] bg-[#262750]'
                            : 'bg-[#2631fb] border border-[#6568fb] text-white '
                            } text-sm flex items-center justify-center rounded-lg cursor-pointer`}
                        onClick={() =>
                            !verifyLoadingStates[item.id] && TaskItemClick(item)
                        }
                    >
                        {verifyLoadingStates[item.id] ? (
                            <span className="veloading text-sm">Verifying</span>
                        ) : (
                            'Go'
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const renderWaitItem = (item) => (
        <div className="w-full mt-2" key={item.id}>
            <div
                className="h-full rounded-lg flex flex-col p-2 mb-2 task-collbody"
            >
                <div className="flex-grow">
                    <p className="text-base">{item.title}</p>
                    <div className="text-sm font-semibold h-8 text-white rounded inline-flex items-center px-2 desc-cor">
                        <span className="mr-2">{item.description}</span>
                    </div>
                </div>
                <div className="flex items-center justify-between text-xs">
                    <div className="w-32 flex justify-between">
                        {item.tasks_prize.map((taskPrize, index) => (
                            <div
                                key={index}
                                className="h-6 rounded-full flex items-center justify-center p-2"
                            >
                                {renderTaskPrize(taskPrize)}
                            </div>
                        ))}
                    </div>
                    <div className={`w-24 h-7 ${taskLoadingStates[item.id] ? 'bg-[#2631fb]' : 'bg-[#2631fb]'} border border-[#6568fb] text-white text-[14px] flex items-center justify-center rounded-lg cursor-pointer`} onClick={() => !taskLoadingStates[item.id] && claimRewards(item)}>
                        {taskLoadingStates[item.id] ? (
                            <span className="loading loading-spinner"></span>
                        ) : (
                            'claim'
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const renderCompletedTaskItem = (item) => (
        <div className="w-full mt-2" key={item.id}>
            <div className="h-full rounded-lg flex flex-col p-2 mb-2 comtask-body">
                <div className="flex-grow">
                    <p className="text-base">{item.title}</p>
                    <div className="text-sm font-semibold h-8 text-white rounded inline-flex items-center px-2 desc-cor">
                        <span className="mr-2">{item.description}</span>
                    </div>
                </div>
                <div className="flex items-center justify-between text-xs">
                    <div className="w-32 flex justify-between">
                        {item.tasks_prize.map((taskPrize, index) => (
                            <div
                                key={index}
                                className="h-6  rounded-full flex items-center justify-center p-2"
                            >
                                {renderTaskPrize(taskPrize)}
                            </div>
                        ))}
                    </div>
                    <div className='w-24 h-7 bg-[#262750]  text-[#999999] text-[14px] flex items-center justify-center rounded-lg'>
                        Completed
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <div>
                <main className="w-full p-1">
                    <div className="flex flex-col items-center ">
                        <div className='w-[89%] lg:h-[38rem] overflow-x-scroll custom-scrollbar'>
                            <>
                                {waitGetAwardData.length > 0 && waitGetAwardData.map(renderWaitItem)}
                                {TaskItems.length > 0 && TaskItems.map((category, index) => (
                                    <div key={index}>{category.items.map(renderTaskItem)}</div>
                                ))}
                                {comTaskListData.length > 0 && comTaskListData.map(renderCompletedTaskItem)}
                            </>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}
